import React, { useEffect, useState } from 'react';
import Home_page_product3_single_item from './Home_page_product3_single_item.js';
import "./Home_page_product3.css";
import { useNavigate } from 'react-router-dom';

function Home_page_product3() {
  const [catagories, setCatagories] = useState([
    "Mobile & Tab",
    "Digital Game & Accessories",
    "Computer & Laptop",
    "Cameras & Accessories",
    "TV & Home Entertainment",
    "Audio",
  ]);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const latestElectronicProducts = [
    "SM-S938BZBCINS S25 ULTRA TITANIUM SILVER BLUE (12GB+512GB)",
    "IPHONE 16 ULTRAMARINE 128GB",
    "GOOGLE MOBILE PIXEL 8A OBSIDIAN 256GB",
    "HP LAPTOP 15-FD0061TU",
    "FTKM50UV16VA INDOOR",
    "UA32T4360AKXXL",
    "215 IMPRO ROY 3S SAPPHIRE PEONY-Z",
    "WT EON ADR 70 5.0 PFDTN GP GR",
    ];
  // async function fetchProducts() {
  //   try {
  //     const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         queryStringParameters: {
  //           "field": "Short_description",
  //           "value": "latest"
  //         }
  //       }),
  //     });
  //     const data = await response.json();
  //     const cleanedBody = data.body.replace(/NaN/g, 'null');
  //     const parsedData = JSON.parse(cleanedBody);
  //     setProducts(parsedData.slice(0, 8));
  //   } catch (error) {
  //     console.log("Error fetching data:", error);
  //   }

  // }

  const fetchProductDetails = async (productId) => {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            queryStringParameters: {
              field: "Model",
              value: productId,
            },
          }),
        }
      );

      const data = await response.json();
      console.log("Data of product details page:", data);
      const cleanedBody = data.body.replace(/NaN/g, "null");
      const parsedData = JSON.parse(cleanedBody);
      console.log("Parsed data of product details page:", parsedData);
      return parsedData[0];
    } catch (err) {
      console.error(`Error fetching details for ${productId}:`, err);
      return null;
    }
  };

  const fetchAllProducts = async () => {
    
    try {
      const productDetailsPromises = latestElectronicProducts.map(productId => 
        fetchProductDetails(productId)
      );
      
      // Wait for all API calls to complete
      const productDetailsResults = await Promise.all(productDetailsPromises);
      
      // Filter out any null results (failed requests)
      // const validProducts = productDetailsResults.filter(product => product !== null);
      
      setProducts(productDetailsResults);
    } catch (err) {
      console.error("Error fetching all products:", err);
    }
  };
  useEffect(() => {
    // fetchProducts();
    fetchAllProducts();
  },[])
  return (
    <div className='Home_page_product3_container'>
      <div className='Home_page_product3_category_container'>
        <h5>Category</h5>
        <div className='Home_page_product3_category'>
          {
            catagories.map((category, index) => (
              <button className="Home_page_product3_category_button" onClick={() => navigate(`/category/${category}`)}>{category}</button>
            ))
          }
        </div>
        <a href='#'>
          <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/11/banner-1.png" className='Home_page_product3_category_banner' />
        </a>
      </div>
      <div className='Home_page_product3_Latest_container'>
        <h4 className='Home_page_product3_Latest_heading'>LATEST ELECTRONICS PRODUCTS</h4>
        <div className="Home_page_product3_product_container">
          {
            products.map((product, index) => (
              <Home_page_product3_single_item product={product} />
            ))
          }
        </div>
      </div>

    </div>
  );
}

export default Home_page_product3;